import {apiGet, apiPost, apiPut, apiDelete, apiDownload} from './apiClient';

/**
 * API для работы с массовой загрузкой отправлений
 */

/**
 * Загрузить Excel файл
 * @param {File} file - файл для загрузки
 * @returns {Promise}
 */
export function uploadMassUploadFile(file) {
    const formData = new FormData();
    formData.append('file', file);

    // Используем apiPost который автоматически добавит правильный базовый URL
    return apiPost('massupload/upload', formData);
}

/**
 * Получить список файлов пользователя
 * @returns {Promise}
 */
export function getMassUploadFiles() {
    return apiGet('massupload/files');
}

/**
 * Получить детали файла
 * @param {number} fileId - ID файла
 * @returns {Promise}
 */
export function getMassUploadFileDetails(fileId) {
    return apiGet(`massupload/files/${fileId}`);
}

/**
 * Обновить отправление
 * @param {number} parcelId - ID отправления
 * @param {object} updatedData - обновленные данные
 * @param {string} fieldName - Опциональное имя поля для валидации только этого поля (например, "senderAddress" или "recipientAddress")
 * @returns {Promise}
 */
export function updateMassUploadParcel(parcelId, updatedData, fieldName = null) {
    let url = `massupload/parcels/${parcelId}`;
    if (fieldName) {
        url += `?fieldName=${encodeURIComponent(fieldName)}`;
    }
    return apiPut(url, updatedData);
}

/**
 * Удалить отправления из файла
 * @param {number} fileId - ID файла
 * @param {number[]} parcelIds - массив ID отправлений
 * @returns {Promise}
 */
export function deleteMassUploadParcels(fileId, parcelIds) {
    return apiDelete(`massupload/files/${fileId}/parcels`, {parcelIds});
}

/**
 * Удалить файл полностью
 * @param {number} fileId - ID файла
 * @returns {Promise}
 */
export function deleteMassUploadFile(fileId) {
    return apiDelete(`massupload/files/${fileId}`);
}

/**
 * Скачать исходный файл массовой загрузки
 * @param {number} fileId - ID файла
 * @returns {Promise}
 */
export function downloadMassUploadSourceFile(fileId) {
    return apiGet(`massupload/files/${fileId}/source`)
        .then(data => {
            const apiBaseUrl = window.getApiBaseUrl();
            const fileUrl = apiBaseUrl + 'files/' + data.result;
            window.location.href = fileUrl;
        })
        .catch(err => {
            console.error('Failed to download mass upload source file:', err);
            throw err;
        });
}

/**
 * Создать отправления из файла
 * @param {number} fileId - ID файла
 * @returns {Promise}
 */
export function createParcelsFromFile(fileId) {
    return apiPost(`massupload/files/${fileId}/create`, {});
}

/**
 * Скачать шаблон Excel
 * @returns {Promise}
 */
export function downloadMassUploadTemplate() {
    return apiGet('massupload/template')
        .then(data => {
            const apiBaseUrl = window.getApiBaseUrl();
            const fileUrl = apiBaseUrl + 'files/' + data.result;
            window.location.href = fileUrl;
        })
        .catch(err => {
            console.error('Failed to download template:', err);
            throw err;
        });
}




// WEBPACK FOOTER //
// ./App/services/massUploadApi.js